<template>
  <div class="card-208">
    <div class="card-208-wrapper rounded">
      <div class="row">
        <div class="col-8 ">
          <slot name="p-1">
            <h4 class="mt-1 mr-2">
              نام محصول
            </h4>
            <p class="mt-2 mr-2">
              توضیحات محصول مورد نظر
            </p>
          </slot>
          <div class="col p-0 my-2">
            <slot name="p-3"></slot>
          </div>
        </div>
        <div class="col-4 text-center ">
          <m-img class="card-208-img " :src="image" :alt="alt"/>
        </div>

        <div class="col-12 my-2">
          <div class="d-flex mx-2 justify-content-between align-items-center">
            <slot name="p-2">
              <div class="price-card d-flex align-items-center">
                <m-img class="card-208-content-img ml-2" :src="image" :alt="alt"/>
                <div class="price-card-title">
                  <p class="price-card-description">حجم محصول</p>
                  <p>۱۰۰۰ تومان</p>
                </div>
              </div>
              <button class="btn-card btn text-white bg-primary shadow-sm  px-4 py-1">افزودن</button>
            </slot>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";


export default {
  name: "Card208",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
}

</script>

<style scoped>
.card-208-wrapper {
  height: auto;
  padding: 9px;
  width: 100%;
}

.card-208-img {
  border-radius: 1rem;
}

.btn-card {
  border-radius: 3rem;
}

.card-208-content-img {
  height: 50px;
  object-fit: cover;
  width: 30px;
}

</style>